import gql from 'graphql-tag'

export const GET_ASSET = gql`
  query asset(
    $id: ID!
  ) {
    asset(
      id: $id
    ) {
      id
      contentType
      title
      caption
      urlWithProtocol
      path
      type
      size
      position
      width
      height
      duration
      status
      source
    }
  }
`